import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import { FaCheck, FaEraser } from 'react-icons/fa';

import FieldController from '../../controller/FieldController';
import Const from '../../util/Constants';

import FilterText from '../filter/FilterText';
import FilterNumber from '../filter/FilterNumber';
import FilterDate from '../filter/FilterDate';
import FilterMultiSelect from '../filter/FilterMultiSelect';
import FilterCity from '../filter/FilterCity';
import FilterState from '../filter/FilterState';
import FilterCountry from '../filter/FilterCountry';
import FilterComplete from './FilterComplete';

import './Filter.css';

class FilterPannel extends React.Component {

  static Equals = 'equals';
  static NotEquals = 'not-equals';
  static In = 'in';
  static NotIn = 'not-in';
  static Empty = 'empty';
  static NotEmpty = 'not-empty';
  static StartWith = 'start-with';
  static EndsWith = 'end-with';
  static GreaterThan = 'greater-than';
  static SmallerThan = 'smaller-than';
  static Null = "null";
  static NotNull = "not-null";

  static Today = 'today';
  static Tomorrow = 'tomorrow';
  static Yesterday = 'yesterday';
  static ThisMonth = 'this-month';
  static NextMonth = 'next-month';
  static LastMonth = 'last-month';
  static Last90Days = 'last-90-days';
  static Next7Days = 'next-7-days';
  static Last7Days = 'last-7-days';
  static Next15Days = 'next-15-days';
  static Last15Days = 'last-15-days';

  static LoggedInUser = 'logged-in-user';
  static LoggedInUserTeam = 'logged-in-user-team';

  constructor(props) {
    super(props);
    this.state = { changed: false, isOpen: false, search: '' };
    this.filters = props.filters;
    this.fields = FieldController.getFilterFields(props.fields, props.view, true);
    this.createFieldList();
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.filters = props.filters;
    this.fields = FieldController.getFilterFields(props.fields, props.view, true);
    this.createFieldList();
  }

  createFieldList = () => {
    this.fields = this.fields.sort((left, right) => {
      const filter1 = this.filters.find(item => item.field === left.fieldKey);
      const filter2 = this.filters.find(item => item.field === right.fieldKey);
      if(filter1 && filter2) return left.label_name.localeCompare(right.label_name);
      if(filter1) return -1;
      if(filter2) return 1;
      return left.label_name.localeCompare(right.label_name);
    });
  }

  clearFilters = () => { 
    this.setState({ ...this.state, search: '' });
    this.filters = [];
    this.props.onFilterChange(this.filters); 
  }
  applyFilters = () => {
    this.setState({ ...this.state, search: '' });
    this.props.onFilterChange(this.filters);
  }

  onSearch = event => {
    this.setState({ ...this.state, search: event.target.value });
  }

  onValueChange = (field, condition, value) => {
    let filter = this.filters.find(item => item.field === field);
    if(!filter) {
      filter = { field };
      this.filters.push(filter);
    }
    filter.condition = condition;
    filter.value = value;
  }

  deleteFilter = field => {
    this.filters = this.filters.filter(item => item.field !== field);
    this.setState({ ...this.state, changed: !this.state.changed});
  }

  resetFilter = field => {
    this.filters = this.filters.filter(item => item.field !== field);
    this.createFieldList();
    this.setState({ ...this.state, changed: !this.state.changed});
  }

  loadFilter = (field, i) => {
    const filter = this.filters.find(item => item.field === field.fieldKey);
    const type = field.field_type;
    if(type === Const.Text || type === Const.TextArea || type === Const.MultiValue
      || type === Const.Street || type === Const.Pin
      || type === Const.Phone  || type === Const.Email) {
      return <FilterText key={`filter_value_${i}`} filter={filter} field={field} 
        onValueChange={this.onValueChange} deleteFilter={this.deleteFilter} 
        resetFilter={this.resetFilter} />;
    } else if(type === Const.Number || type === Const.Duration || type === Const.Decimal) {
      return <FilterNumber key={`filter_value_${i}`} filter={filter} field={field}
        onValueChange={this.onValueChange} deleteFilter={this.deleteFilter} 
        resetFilter={this.resetFilter} />;
    } else if(type === Const.Date || type === Const.DateTime) {
      return <FilterDate key={`filter_value_${i}`} index={i} filter={filter} field={field}
        onValueChange={this.onValueChange} deleteFilter={this.deleteFilter}
        resetFilter={this.resetFilter} />;
    } else if(type.includes(Const.Select)) {
      return <FilterMultiSelect key={`filter_value_${i}`} index={i} filter={filter} field={field} 
        onValueChange={this.onValueChange} deleteFilter={this.deleteFilter}
        resetFilter={this.resetFilter} restrict={this.props.restrict} />;
    } else if(type === Const.Complete || type === Const.Toggle) {
      return <FilterComplete key={`filter_value_${i}`} index={i}
        filter={filter} field={field} onValueChange={this.onValueChange} 
        deleteFilter={this.deleteFilter} resetFilter={this.resetFilter} />;
    } else if(type === Const.City) {
      return <FilterCity key={`filter_value_${i}`} index={i} filter={filter} field={field} 
        onValueChange={this.onValueChange} deleteFilter={this.deleteFilter}
        resetFilter={this.resetFilter} />;
    } else if(type === Const.State) {
      return <FilterState key={`filter_value_${i}`} index={i} filter={filter} field={field}
        onValueChange={this.onValueChange} deleteFilter={this.deleteFilter}
        resetFilter={this.resetFilter} />;
    } else if(type === Const.Country) {
      return <FilterCountry key={`filter_value_${i}`} index={i} field={field} filter={filter}
        onValueChange={this.onValueChange} deleteFilter={this.deleteFilter}
        resetFilter={this.resetFilter} />;
    } else if(type === Const.Model && field.field_key === "model_id" && field.model_no === Const.Property) {
      console.log({type, field })
      return <FilterComplete key={`filter_value_${i}`} index={i}
        filter={filter} field={field} onValueChange={this.onValueChange} 
        deleteFilter={this.deleteFilter} resetFilter={this.resetFilter} />;
    }
    return null;
  }

  render() {
    if(!this.props.isFilterOpen) {
      return null;
    }
    const uiFilters = [];
    for(let i = 0; i < this.fields.length; i++) {
      if(this.fields[i].label_name.toLowerCase().includes(this.state.search.toLowerCase())) {
        const filter = this.loadFilter(this.fields[i], i);
        if(filter) { 
          uiFilters.push(filter);
        }
      }
    }
    return (
      <div className="col-md-3 point5 filtersec">
        <div className="m-20p">
          <div className="stickytop">
            <div className="col-md-12 d-flexx">
              <span className="wi-35">
                <FormControl type="text" value={this.state.search} onChange={this.onSearch}
                  placeholder="Column Name" />
              </span>
              <span className="wi-20" onClick={this.applyFilters}>
                <span className="btn btn-lead btn-sm"><FaCheck /> Apply</span>
              </span>
              <span className="wi-20" onClick={this.clearFilters}> 
                <span className="btn btn-lead btn-sm"><FaEraser /> Clear</span>
              </span>
              <span className="wi-20" onClick={this.props.closeFilter}> 
                <span className="btn btn-lead btn-sm">&times; Close</span>
              </span>
            </div>
            </div>
        </div>
        <hr />
        <div className="filtersecd p-4">{ uiFilters }</div>
      </div>
    );
  }
}

export default FilterPannel;
